<script>
	import { Tabs, TabList, TabPanel, Tab } from "../components/tabs/tabs";
	import RestaurantBox from '../components/RestaurantBox.svelte';
	import MainMenu from '../components/MainMenu.svelte';
	import BarMenu from '../components/BarMenu.svelte';
	let menu = [];
	fetch('https://www.mangomist.com/mangomist/api/restaurant/restaurant_menu').then(res => res.json()).then(res => menu = res);
	let restaurantdata = [
		{
			name: "A RUSTIC CAFE",
			icon: "Coffee-Shop.jpg",
			covers: "80",
			optionalhours: "24 hrs",
			buffet: "Break Fast / Lunch / Dinner"
		},
		{
			name: "HALL OF PILLARS",
			icon: "Beach-Wood.jpg",
			covers: "60",
			optionalhours: "9am to 11pm",
			buffet: "Lunch"
		},
		{
			name: "A BBQ RESTAURANT",
			icon: "BBQ.jpg",
			covers: "80",
			optionalhours: "1 pm to 3 pm / 7pm to 9pm",
			buffet: "Lunch / Dinner"
		},
		{
			name: "A LAKESIDE CAFE",
			icon: "Tea-Tree.jpg",
			covers: "120",
			optionalhours: "1 pm to 3 pm / 4 pm to 6 pm",
			buffet: "Lunch / Hi Tea"
		},
		{
			name: "COMPLIMENTARY DRINKS SERVED",
			icon: "Mocktini.jpg",
			covers: "70",
			optionalhours: "9 am to 6 pm",
			buffet: " "
		},
		{
			name: "A POOLSIDE BAR",
			icon: "Aqua-Bar.jpg",
			covers: "80",
			optionalhours: "7 pm to 9 pm",
			buffet: " "
		}
	];
</script>

<div class="image-background">
	<h1 class="header_text_wrapper text-left"><span>Restaurant</span><span class="separator"></span></h1>
</div>
<div class="primary">
	<Tabs>
		<TabList>
			<Tab>
				<i class="vc_tta-icon fa fa-cutlery"></i>
				RESTAURANT
			</Tab>
			<Tab>
				<i class="fa fa-spoon" aria-hidden="true"></i>
				FOOD
			</Tab>
			<Tab>
				<i class="fa fa-glass" aria-hidden="true"></i>
				BAR
			</Tab>
		</TabList>

		<TabPanel>
			<div class="container-fluid">
				{#each restaurantdata as item}
					<RestaurantBox name={item.name} icon={item.icon} covers={item.covers} optionalhours={item.optionalhours} buffet={item.buffet} />
				{/each}
			</div>
		</TabPanel>
		<TabPanel>
			<div class="main-menu-box">
				<MainMenu menu={menu.find(i => i.name == 'RESTAURANT')}/>
			</div>
		</TabPanel>

		<TabPanel>
			<div class="main-menu-box">
				<MainMenu menu={menu.find(i => i.name == 'BAR')}/>
			</div>
		</TabPanel>
	</Tabs>
</div>

<style>
    .image-background {
        background: url("../images/Restaurant1.jpg") no-repeat center;
    }

	.primary {
		background: rgba(0, 0, 0, 0) url("../images/gpattern-opacity-1.png") repeat scroll 0 0;
	}

	.main-menu-box {
		padding: 35px 10px;
	}

	.fa-glass:before {
		content: "\f000";
	}
</style>